import { Client, Room } from 'colyseus.js';
import type { ModelInstance } from '../render/instanced-layout';

/**
 * Connects to the dungeon-generation preview room (backend
 * src/game/dungeon-generation/rooms/dungeon-preview.room.ts). Same
 * cookie-based auth as the movement/combat prototype's colyseus-client.ts —
 * no token in join options, the browser attaches the `gamer_id` cookie to
 * this same-origin WebSocket handshake automatically.
 */

const COLYSEUS_URL = import.meta.env.VITE_COLYSEUS_URL || `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/colyseus`;

export interface DungeonLayoutPayload {
  seed: number;
  isFallback: boolean;
  roomCount: number;
  instances: ModelInstance[];
}

export interface PreviewJoinResult {
  room: Room;
  layout: DungeonLayoutPayload;
}

export async function joinDungeonPreview(seed?: number): Promise<PreviewJoinResult> {
  const client = new Client(COLYSEUS_URL);
  const room = await client.joinOrCreate('dungeon_preview', seed !== undefined ? { seed } : {});

  // Handler must be registered before requesting — colyseus.js drops any
  // message that arrives before a matching onMessage() call, no buffering.
  const layout = await new Promise<DungeonLayoutPayload>((resolve) => {
    room.onMessage('dungeon.layout', (msg: DungeonLayoutPayload) => resolve(msg));
    room.send('request.layout');
  });

  return { room, layout };
}
